import { useSelector } from 'react-redux';
import FJAppConstant from '../../../constants/FJAppConstant.js';
import FJConfig from '../../../config/FJConfig.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import styles from './FJHeader1Container.module.less';
import useLocalStore from '../../../hooks/useLocalStore.js';

const CONFIG = {
    [FJAppConstant.IMAGE_TO_IMAGE]: { iconName: 'ai-image-to-image.svg', title: 'image-to-image' },
    [FJAppConstant.PHOTO_RESTORATION]: { iconName: 'old-photo-restoration.svg', title: 'ai-old-photo-restoration' },
    [FJAppConstant.PHOTO_COLORIZE]: { iconName: 'ai-photo-colorizer.svg', title: 'ai-photo-colorizer' },
    [FJAppConstant.IMAGE_ENHANCER]: { iconName: 'ai-image-upscaler.svg', title: 'ai-image-upscaler' },
    [FJAppConstant.TEXT_TO_IMAGE]: { iconName: 'ai-image-generator.svg', title: 'text-to-image' },
    [FJAppConstant.IMAGE_EXTENDER]: { iconName: 'ai-image-extender.svg', title: 'ai-image-extender' },
    [FJAppConstant.FACE_SWAP]: { iconName: 'ai-face-swap.svg', title: 'ai-face-swap' },
    [FJAppConstant.FAKE_3D]: { iconName: '3d-motion.svg', title: '3d-photo-animation' },
    [FJAppConstant.OBJECT_ERASER]: { iconName: 'ai-object-remover.svg', title: 'ai-object-removal' },
    [FJAppConstant.PHOTO_REMOVE_BG]: { iconName: 'image-background-remove.svg', title: 'ai-image-bg-remover' },
    [FJAppConstant.AI_VIDEO_GENERATOR]: { iconName: 'ai-image-to-video.svg', title: 'ai-image-to-video' },
    [FJAppConstant.AI_AUDIO_GENERATOR]: { iconName: 'ai-music.svg', title: 'ai-music-generator' },
    [FJAppConstant.CLOTHES_CHANGER]: { iconName: 'clothes-changer.svg', title: 'ai-clothes-changer' },
};

const FJHeader1Container = () => {
    useLocalStore();
    const appType = useSelector(state => state.common.appType);

    const data = CONFIG[appType];
    if (!data) return;

    return (
        <div className={styles.header_panel}>
            <img src={`${FJConfig.imgPath}header/${data.iconName}`} className={styles.image} />
            <div className={styles.title}>{FJLocalStore._(data.title)}</div>
        </div>
    );
};

export default FJHeader1Container;
